
import { InfoIcon, PhoneIcon, SettingsIcon, MapPinIcon } from "lucide-react";
import Contact from "./pages/Contact.jsx";
import About from "./pages/About.jsx";
import Locations from "./pages/Locations.jsx";
import Services from "./pages/Services.jsx";

export const navItems = [
  {
    title: "Services",
    to: "/services",
    icon: <SettingsIcon className="h-4 w-4" />,
    page: <Services />,
  },
  {
    title: "Locations",
    to: "/locations",
    icon: <MapPinIcon className="h-4 w-4" />,
    page: <Locations />,
  },
  {
    title: "About",
    to: "/about",
    icon: <InfoIcon className="h-4 w-4" />,
    page: <About />,
  },
  {
    title: "Contact",
    to: "/contact",
    icon: <PhoneIcon className="h-4 w-4" />,
    page: <Contact />,
  },
];

